"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToastBody_unstable", {
    enumerable: true,
    get: function() {
        return useToastBody_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _toastContainerContext = require("../../contexts/toastContainerContext");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const useToastBody_unstable = (props, ref)=>{
    const backgroundAppearance = (0, _reactsharedcontexts.useBackgroundAppearance)();
    const { bodyId } = (0, _toastContainerContext.useToastContainerContext)();
    return {
        components: {
            root: 'div',
            subtitle: 'div'
        },
        subtitle: _reactutilities.slot.optional(props.subtitle, {
            elementType: 'div'
        }),
        root: _reactutilities.slot.always((0, _reactutilities.getIntrinsicElementProps)('div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            id: bodyId,
            ...props
        }), {
            elementType: 'div'
        }),
        backgroundAppearance
    };
};
